import { render, staticRenderFns } from "./ListTokenHistory.vue?vue&type=template&id=3afc0d56"
import script from "./ListTokenHistory.vue?vue&type=script&lang=js"
export * from "./ListTokenHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports